import type { VBannerItem } from 'v-ui'

type VBannerDraft = Omit<VBannerItem, 'name'> & { name?: string }

export const toVBannerItems = (items: VBannerDraft[]): VBannerItem[] =>
  items.map(item => ({
    ...item,
    name: item.name ?? item.alt ?? String(item.id)
  }))
